import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {WorkerPosition} from '../../worker-position/worker-position.model';

@Injectable()
export class WorkerPositionsResolver implements Resolve<Observable<WorkerPosition[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<WorkerPosition[]> {
    return this.facadeService.getAllWorkerPositions().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
